(function ($, UX) {
    UX.form = UX.form || {};

    UX.form.init = function () {
        UX.form.select();
    };

    UX.form.select = function () {
        $('select.jcf').wrap('<div class="select"/>').parent().append('<span class="after"/>');
    };

    // init self on ready
    $(document).ready(UX.form.init);
})(jQuery, UX);
